import * as React from "react";

import {
  Card,
  CardHeader,
  PrimaryButton,
  SecondaryButton,
} from "@stenajs-webui/elements";
import { IndentValues } from "@/lib/utils/IndentValues";
import { Box, Indent, Row, Space, Txt } from "@stenajs-webui/core";
import {
  StandardTable,
  createStandardTableInitialState,
  useLocalStateTableContext,
} from "@stenajs-webui/grid";
import { useMemo, useState } from "react";
import { SpaceValues } from "@/lib/utils/SpaceValues";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router";
import { ChildSelectorTableColumnKeys } from "../../config/RowAndColumnConfig";
import { ChildSelectorTableConfig } from "../../config/ChildSelectorTableConfig";
import {
  ChildCustomersByStatusFragment,
  ChildSelectorQuery,
  ChildSelectorQueryVariables,
} from "@/gql/graphql";
import { childSelectorQuery } from "../../queries/childSelectorQuery";
import { Switch } from "@stenajs-webui/forms";
interface Props {
  headAgreementYear: number;
  setChildCustomers: React.Dispatch<
    React.SetStateAction<ChildCustomersByStatusFragment[]>
  >;
  setCreateReportForChildren: React.Dispatch<React.SetStateAction<boolean>>;
  setChildrenForReport: React.Dispatch<
    React.SetStateAction<string[] | undefined>
  >;
  parentId: string;
}

export const ChildSelector: React.FC<Props> = ({
  headAgreementYear: year,
  setChildCustomers,
  setChildrenForReport,
  setCreateReportForChildren,
  parentId,
}) => {
  const { headAgreementId, customerId, reportType } = useParams() as {
    headAgreementId: string;
    customerId: string;
    reportType: string;
  };

  const { data, loading, error } = useQuery<
    ChildSelectorQuery,
    ChildSelectorQueryVariables
  >(childSelectorQuery, {
    variables: {
      customerId,
      year,
      agreementId: headAgreementId,
      agreementDocumentType: reportType,
    },
    fetchPolicy: "network-only",
    onCompleted(data) {
      setChildCustomers(
        data?.productPrice?.customers?.byId?.childCustomersByStatus ?? []
      );
    },
  });

  const [includeParent, setIncludeParent] = useState<boolean>(false);

  const childCustomers =
    data?.productPrice.customers.byId?.childCustomersByStatus;

  const initialState = useMemo(
    () => createStandardTableInitialState<ChildSelectorTableColumnKeys>(),
    []
  );

  const { tableContext } = useLocalStateTableContext(
    "multi-leg-agreement-table-head-agreement",
    initialState
  );

  const selectedIds = tableContext.state.selectedIds.selectedIds;

  const handleSubmit = () => {
    const idsForReport = includeParent
      ? [...selectedIds, parentId]
      : selectedIds;
    setChildrenForReport(idsForReport);
  };

  const selectedChildAndParentIds = includeParent
    ? [...selectedIds, parentId]
    : selectedIds;

  return (
    <Box indent={IndentValues.TWENTYFOUR}>
      <Card>
        <CardHeader
          text={"Select Accounts"}
          contentRight={
            <>
              <SecondaryButton
                label="Cancel"
                variant="danger"
                onClick={() => setCreateReportForChildren(false)}
              />
              <Space />
              <PrimaryButton
                label="Next"
                disabled={selectedChildAndParentIds.length === 0}
                onClick={() => handleSubmit()}
              />
            </>
          }
        />
        <Space num={1} />

        <Indent num={IndentValues.EIGHT}>
          <Row indent={IndentValues.SIXTEEN}>
            <Txt size={"medium"} variant={"standard"}>
              Include parent
            </Txt>
            <Space num={2} />
            <Switch
              value={includeParent}
              onValueChange={() => setIncludeParent(!includeParent)}
            />
            <Space num={4} />
          </Row>

          <StandardTable
            config={ChildSelectorTableConfig}
            items={childCustomers}
            tableContext={tableContext}
            loading={loading}
            error={error}
          />
        </Indent>
        <Space num={SpaceValues.SIXTEEN} />
      </Card>
    </Box>
  );
};
